// extracted by mini-css-extract-plugin
export default {"inputsWrapper":"SignIn_inputsWrapper__eIsYh","btnsWrapper":"SignIn_btnsWrapper__fYxjE"};